var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.journals),function(journal){return _c('journal',{key:journal.id,attrs:{"journal":journal,"issue":_vm.issue}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }